import { useEffect, useState } from "react";
import {
    Box,
    Button,
    Checkbox,
    Divider,
    FormControlLabel,
    Menu,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";
import { translate } from "../../../../../translate/translate";

interface BomFilterMenuProps {
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
    onApplyFilters: (filterType: string, showChildren: boolean) => void;
    selectedFilterType: string;
    selectedShowChildren: boolean;
}

const sectionTitleStyle = {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14.5px",
    lineHeight: "100%",
    margin: "0px 0px 10px 0px",
    color: "#546E7A",
    marginTop: "10px",
};

const sectionLabelStyle = {
    "& .MuiFormControlLabel-label": {
        fontFamily: "Inter",
        fontSize: "14.5px",
        fontWeight: 500,
        color: "#45485F",
    },
};

const BomFilterMenuComponent = ({
    anchorEl,
    open,
    onClose,
    onApplyFilters,
    selectedFilterType,
    selectedShowChildren,
}: BomFilterMenuProps) => {
    const [tempFilterType, setTempFilterType] = useState<string>(selectedFilterType);
    const [tempShowChildren, setTempShowChildren] = useState(selectedShowChildren);

    useEffect(() => {
        if (open) {
            setTempFilterType(selectedFilterType);
            setTempShowChildren(selectedShowChildren);
        }
    }, [open, selectedFilterType, selectedShowChildren]);

    const handleApply = () => {
        onApplyFilters(tempFilterType, tempShowChildren);
        onClose();
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            MenuListProps={{
                "aria-labelledby": "btn-filter-bom",
            }}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: "12px",
                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.12)",
                        minWidth: 220,
                        p: 2,
                    },
                },
            }}
        >
            <Typography sx={{ ...sectionTitleStyle, mb: 0.5 }}>
                {translate.t("filter_by")}
            </Typography>

            <Divider />

            <RadioGroup
                value={tempFilterType}
                onChange={(e) => setTempFilterType(e.target.value)}
            >
                <FormControlLabel
                    value="all"
                    control={<Radio size="small" />}
                    label={translate.t("all")}
                    sx={{ ml: 0, ...sectionLabelStyle }}
                />
                <FormControlLabel
                    value="phantom"
                    control={<Radio size="small" />}
                    label={translate.t("phantom")}
                    sx={{ ml: 0, ...sectionLabelStyle }}
                />
                <FormControlLabel
                    value="imperfect"
                    control={<Radio size="small" />}
                    label={translate.t("imperfect")}
                    sx={{ ml: 0, ...sectionLabelStyle }}
                />
            </RadioGroup>

            <Typography sx={{ ...sectionTitleStyle, mb: 0.5 }}>
                {translate.t("list_structure")}
            </Typography>

            <Divider />

            <FormControlLabel
                control={
                    <Checkbox
                        size="small"
                        checked={tempShowChildren}
                        onChange={(e) => setTempShowChildren(e.target.checked)}
                    />
                }
                label={translate.t("show_related")}
                sx={{ ml: 0, ...sectionLabelStyle }}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button
                    variant="outlined"
                    color="primary"
                    size="medium"
                    onClick={handleApply}
                    sx={{
                        textTransform: "none",
                        borderRadius: "4px",
                        fontWeight: 500,
                    }}
                >
                    {translate.t("apply")}
                </Button>
            </Box>
        </Menu>
    );
};

export default BomFilterMenuComponent;
